import React from 'react';
import { Carousel } from 'antd';

import nanosatellite from '../../../../Assets/Linkages/StudentSatelliteOutreach/Legacy/build-a-nanosatellite-2024.jpg';
import cansatWorkshop from '../../../../Assets/Linkages/StudentSatelliteOutreach/Legacy/cansat-workshop.jpg';
import destinationSchool from '../../../../Assets/Linkages/StudentSatelliteOutreach/Legacy/space-destination-school.png';
import stemTechnology from '../../../../Assets/Linkages/StudentSatelliteOutreach/Legacy/stem-for-space-technology.jpg';
import nationalCompetition from '../../../../Assets/Linkages/StudentSatelliteOutreach/Legacy/national-cansat-competition-2024.jpg';
import buildCansat from '../../../../Assets/Linkages/StudentSatelliteOutreach/Legacy/lets-build-a-cansat-2023.png';
import destinationSchool2023 from '../../../../Assets/Linkages/StudentSatelliteOutreach/Legacy/space-destination-school-2023.png';
import makerCamp from '../../../../Assets/Linkages/StudentSatelliteOutreach/Legacy/space-maker-camp.png';

const legacyImages = [
  { src: nanosatellite, alt: 'Build a Nano Satellite program poster' },
  { src: nationalCompetition, alt: 'National CanSat Competition 2024 poster' },
  { src: cansatWorkshop, alt: 'CanSat workshop poster' },
  { src: stemTechnology, alt: 'STEM for Space Technology poster' },
  { src: buildCansat, alt: "Let's Build a CanSat 2023 poster" },
  { src: makerCamp, alt: 'Space Maker Camp poster' },
  { src: destinationSchool, alt: 'Space Destination School program poster' },
  { src: destinationSchool2023, alt: 'Space Destination School 2023 poster' },
];

const StudentSatelliteLegacy = () => (
  <section className="student-satellite-legacy" aria-labelledby="student-satellite-legacy-title">
    <div className="student-satellite-legacy-inner">
      <header className="student-satellite-legacy-header">
        <p className="section-eyebrow">A LEGACY OF HANDS-ON LEARNING</p>
        <h2 id="student-satellite-legacy-title">Our Legacy</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
      </header>

      <p className="student-satellite-legacy-copy">
        Over the years, a pioneering legacy has been established in student satellite development
        through impactful programs including National CanSat Competition, CanSat Workshop, Let&apos;s
        Build a CanSat, Space Maker Camp, STEM for Space Technology, and Space Destination Schools.
        These initiatives have provided practical training to more than 1,500 students from over 15
        academic institutions, igniting curiosity and competence in satellite design and space missions.
        Driven by the mentorship of 10+ domain experts and sustained through 15+ technical lectures and
        15+ practical sessions, the programs serve as a cornerstone for capacity-building in space
        education, empowering students through experiential learning and innovation.
      </p>

      <Carousel
        className="student-satellite-legacy-carousel"
        autoplay
        autoplaySpeed={3200}
        pauseOnHover
        dots
        slidesToShow={4}
        slidesToScroll={1}
        responsive={[
          { breakpoint: 1100, settings: { slidesToShow: 3 } },
          { breakpoint: 800, settings: { slidesToShow: 2 } },
          { breakpoint: 540, settings: { slidesToShow: 1 } },
        ]}
      >
        {legacyImages.map((image) => (
          <div key={image.src} className="student-satellite-legacy-slide">
            <figure>
              <img src={image.src} alt={image.alt} loading="lazy" />
            </figure>
          </div>
        ))}
      </Carousel>
    </div>
  </section>
);

export default StudentSatelliteLegacy;
